import ax from 'axios';

const getAxios = (token) => {
    return ax.create({
        baseURL: process.env.REACT_APP_API_URL,
        Accept: 'application/json',
        headers: { Authorization: `Token ${token}`, 'Accept-Language': 'es' }
    })
};

export default getAxios;


// WEBPACK FOOTER //
// ./src/redux/getAxios.js